import { render } from "./NotFound.vue?vue&type=template&id=1ee6b698&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1ee6b698"

export default script